<template>
    <div class="retail-pickers">
        <pickers ref="pickers">
            <slot />
        </pickers>
    </div>
</template>

<style scoped>
.retail-pickers ::v-deep .pickers {
    border-radius: 20px 20px 20px 20px;
    margin: 0px 6vw 0px 6vw;
    min-height: 230px;
    position: relative;
}

.retail-pickers ::v-deep .pickers .background {
    background-color: #f5f5f5;
    border-bottom: 1px solid #e9eaee;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    height: 95px;
    left: 0px;
    position: absolute;
    right: 0px;
    top: 5px;
}

.retail-pickers ::v-deep .pickers.multiple-materials {
    margin: 0px 1vw 0px 1vw;
}

.retail-pickers ::v-deep .pickers ul {
    list-style: none;
    padding-left: 0px;
}

.retail-pickers ::v-deep .pickers .parts-container {
    font-size: 0px;
    height: 101px;
    margin: 0px 0px 0px 0px;
    overflow-x: auto;
    overflow-y: hidden;
    position: relative;
    white-space: nowrap;
}

.retail-pickers ::v-deep .pickers .parts-container::-webkit-scrollbar {
    background: transparent;
    height: 0px;
}

.retail-pickers ::v-deep .pickers .parts-container > .part {
    background-color: transparent;
    border: 1px solid transparent;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    cursor: pointer;
    display: inline-block;
    height: 100px;
    transition: background-color 0.125s ease-in-out;
    vertical-align: top;
    width: 125px;
}

.retail-pickers ::v-deep .pickers .parts-container > .part.active {
    background-color: #ffffff;
    border-color: #e9eaee #e9eaee transparent #e9eaee;
}

.retail-pickers ::v-deep .pickers .parts-container > .part > p {
    color: #6d6d6d;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    margin: 30px 0px 14px 0px;
    text-transform: uppercase;
}

.retail-pickers ::v-deep .pickers .parts-container > .part > .swatch {
    border: 1px solid #9299a3;
    border-radius: 50% 50% 50% 50%;
    height: 22px;
    margin: 0px auto 0px auto;
    overflow: hidden;
    width: 22px;
}

.retail-pickers ::v-deep .pickers .parts-container > .part > .no-part {
    color: #4d545f;
    line-height: 18px;
    margin: 0px 0px 0px 0px;
    text-transform: capitalize;
}

.retail-pickers ::v-deep .pickers.multiple-materials .materials-container {
    background-color: #ffffff;
    border-left: 1px solid #e9eaee;
    border-right: 1px solid #e9eaee;
    height: 60px;
    margin: 0px 0px 0px 0px;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0px 40px 0px 40px;
    white-space: nowrap;
}

.retail-pickers ::v-deep .pickers.multiple-materials .materials-container::-webkit-scrollbar {
    background: transparent;
    height: 0px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .materials-container > .material {
    display: inline-block;
    vertical-align: top;
}

.retail-pickers ::v-deep .pickers.multiple-materials .materials-container > .material > p {
    border-bottom: 1px solid transparent;
    color: #9b9b9b;
    font-size: 12px;
    height: 12px;
    line-height: 12px;
    margin: 26px 30px 22px 30px;
    text-transform: uppercase;
}

.retail-pickers ::v-deep .pickers.multiple-materials .materials-container > .material.active > p {
    border-bottom-color: #9b9b9b;
    font-weight: 600;
}

.retail-pickers ::v-deep .pickers .colors-container {
    background-color: #ffffff;
    border: 1px solid #e9eaee;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top-width: 0px;
    height: 135px;
    margin: 0px 0px 0px 0px;
}

.retail-pickers ::v-deep .pickers .colors-container > span {
    display: block;
    height: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 0px 20px 0px 20px;
    white-space: nowrap;
}

.retail-pickers ::v-deep .pickers .colors-container > span::-webkit-scrollbar {
    background: transparent;
    height: 0px;
}

.retail-pickers ::v-deep .pickers .colors-container .color {
    cursor: pointer;
    display: inline-block;
    height: 135px;
    opacity: 1;
    position: relative;
    transition: opacity 0.1s ease-in-out;
    user-select: none;
    vertical-align: top;
    width: 100px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color {
    height: 80px;
    margin: 20px 0px 20px 0px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color[data-index="0"] {
    border-left: 1px solid #eaeaec;
    box-sizing: border-box;
    margin-left: 18px;
    padding-left: 36px;
    width: 118px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color[data-index="0"]:first-child {
    border-left-color: transparent;
    margin-left: 0px;
    padding: 0px 0px 0px 0px;
    width: 100px;
}

.retail-pickers ::v-deep .pickers .colors-container .color.list-enter-active {
    opacity: 0;
    position: absolute;
}

.retail-pickers ::v-deep .pickers .colors-container .color.list-leave-active {
    opacity: 0;
}

.retail-pickers ::v-deep .pickers .colors-container .color > p {
    font-size: 14px;
    margin: 100px 0px 0px 0px;
    text-transform: capitalize;
    white-space: normal;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color > p {
    margin-top: 80px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color.active > p {
    font-weight: 600;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color[data-index="0"] > p {
    margin-left: -18px;
    width: 100px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color[data-index="0"]:first-child > p {
    margin-left: 0px;
}

.retail-pickers ::v-deep .pickers .colors-container .color > .swatch {
    border: solid 2px #eaeaec;
    border-radius: 50% 50% 50% 50%;
    height: 64px;
    left: 0px;
    margin: 20px auto 0px auto;
    overflow: hidden;
    padding: 0px 0px 0px 0px;
    position: absolute;
    right: 0px;
    top: 0px;
    transform: scale(1, 1);
    transition: transform 0.125s ease-in-out, border-width 0.125s ease-in-out;
    width: 64px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color > .swatch {
    margin-top: 0px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color[data-index="0"] > .swatch {
    left: 18px;
}

.retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color:first-child > .swatch {
    left: 0px;
}

.retail-pickers ::v-deep .pickers .colors-container .color.active > .swatch {
    border-width: 0px;
    transform: scale(1.13, 1.13);
}

.retail-pickers ::v-deep .pickers .colors-container .color.active.no-option > .swatch {
    border-width: 2px;
}

.retail-pickers ::v-deep .pickers .colors-container .color > .swatch > .border {
    border: 0px solid #ffffff;
    border-radius: 50% 50% 50% 50%;
    bottom: 3px;
    left: 3px;
    position: absolute;
    right: 3px;
    top: 3px;
    transition: border-width 0.125s ease-in-out;
}

.retail-pickers ::v-deep .pickers .colors-container .color.active > .swatch > .border {
    border-width: 4px;
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert-container {
    overflow: hidden;
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert {
    background-color: #f5f5f5;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    display: flex;
    font-size: 11px;
    line-height: 14px;
    margin: 0px auto 0px auto;
    max-width: 100%;
    padding: 10px 20px 10px 30px;
    text-align: left;
    transform: translateY(-100%);
    transition: transform 0.5s ease-in-out;
    width: 78%;
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert.visible {
    transform: translateY(0px);
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert .button-container {
    flex: 0 1;
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert .button-container > .button {
    margin-left: 0px;
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert .button.button-restrictions-alert {
    font-size: 12px;
    font-weight: bold;
    margin-left: 20px;
    padding: 10px 10px 10px 10px;
    text-decoration: underline;
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert .message-container {
    flex: 1 0;
}

.retail-pickers ::v-deep .pickers .message-restrictions-alert .message-container > span {
    user-select: text;
}

@media screen and (max-height: 1340px) {

    .retail-pickers ::v-deep .pickers {
        min-height: 176px;
    }

    .retail-pickers ::v-deep .pickers.multiple-materials {
        margin: 0px 5vw 0px 5vw;
        min-height: 216px;
    }

    .retail-pickers ::v-deep .pickers .background {
        height: 70px;
    }

    .retail-pickers ::v-deep .pickers .parts-container {
        height: 76px;
    }

    .retail-pickers ::v-deep .pickers .parts-container > .part {
        height: 75px;
    }

    .retail-pickers ::v-deep .pickers .parts-container > .part > p {
        font-size: 12px;
        line-height: 12px;
        margin: 20px 0px 12px 0px;
    }

    .retail-pickers ::v-deep .pickers .parts-container > .part > .swatch {
        height: 17px;
        width: 17px;
    }

    .retail-pickers ::v-deep .pickers.multiple-materials .materials-container {
        height: 40px;
    }

    .retail-pickers ::v-deep .pickers.multiple-materials .materials-container > .material > p {
        font-size: 10px;
        height: 10px;
        line-height: 10px;
        margin: 16px 30px 12px 30px;
    }

    .retail-pickers ::v-deep .pickers .colors-container {
        height: 100px;
    }

    .retail-pickers ::v-deep .pickers .colors-container .color {
        height: 80px;
        margin: 10px 0px 10px 0px;
    }

    .retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color {
        margin: 6px 0px 6px 0px;
    }

    .retail-pickers ::v-deep .pickers .colors-container .color > .swatch {
        height: 50px;
        margin-top: 6px;
        width: 50px;
    }

    .retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color > .swatch {
        margin-top: 4px;
    }

    .retail-pickers ::v-deep .pickers .colors-container .color > p,
    .retail-pickers ::v-deep .pickers.multiple-materials .colors-container .color > p {
        font-size: 12px;
        height: 12px;
        line-height: 12px;
        margin-top: 68px;
    }
}
</style>

<script>
export const RetailPickers = {
    name: "retail-pickers"
};

export default RetailPickers;
</script>
